import { FormControl, FormHelperText, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export default function TextInputField({
  name,
  type = "text",
  controller,
  minRows = 0,
  placeholder,
  required = false,
}) {
  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <Controller
        name={name}
        control={controller.control}
        rules={{ required: required }}
        render={({ field: { value, onChange, onBlur } }) => (
          <TextField
            size="small"
            value={value}
            type={type}
            onChange={onChange}
            error={Boolean(controller.errors)}
            minRows={minRows}
            multiline
            placeholder={placeholder}
          />
        )}
      />
      {controller.errors && (
        <FormHelperText sx={{ color: "error.main" }}>
          {controller.errors.message}
        </FormHelperText>
      )}
    </FormControl>
  );
}
